import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import AuthImage from "./AuthImage";
import FollowButton from "./FollowButton";
import { Shield, User, TrendingUp } from "lucide-react";

export function TrendingHashtags() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/feed/trending-hashtags`).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);
  return (
    <aside className="csc-card p-5" data-testid="trending-hashtags">
      <div className="flex items-center gap-2 mb-3">
        <TrendingUp size={14} className="text-[#39ff14]" />
        <h3 className="font-mono-tech text-[10px] uppercase tracking-[0.28em] text-[#94a3b8]">Trending</h3>
      </div>
      {items.length === 0 ? (
        <div className="text-xs text-[#94a3b8] font-mono-tech uppercase tracking-wider">No hashtags yet</div>
      ) : (
        <ul className="space-y-2">
          {items.map((t) => (
            <li key={t.tag}>
              <Link to={`/tag/${t.tag}`} className="flex items-center justify-between hover:text-[#00aaff]" data-testid={`trending-${t.tag}`}>
                <span className="text-sm text-white">#{t.tag}</span>
                <span className="font-mono-tech text-[10px] text-[#94a3b8]">{t.count}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
}

export function SuggestedAccounts() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/profile/suggested`, { params: { limit: 5 } }).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);
  const handleFollow = (idx, following) => {
    if (following) setItems((arr) => arr.filter((_, i) => i !== idx));
  };
  return (
    <aside className="csc-card p-5" data-testid="suggested-accounts">
      <h3 className="font-mono-tech text-[10px] uppercase tracking-[0.28em] text-[#94a3b8] mb-3">Suggested to follow</h3>
      {items.length === 0 ? (
        <div className="text-xs text-[#94a3b8] font-mono-tech uppercase tracking-wider">Nothing here yet</div>
      ) : (
        <ul className="space-y-3">
          {items.map((it, i) => (
            <li key={`${it.type}-${it.id}`} className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full overflow-hidden border border-[rgba(0,170,255,0.18)]">
                <AuthImage
                  src={it.avatar_url}
                  alt=""
                  className="w-full h-full object-cover"
                  fallback={
                    <div className="w-full h-full bg-[#0d1b2e] flex items-center justify-center">
                      {it.type === "org" ? <Shield size={12} className="text-[#00aaff]" /> : <User size={12} className="text-[#39ff14]" />}
                    </div>
                  }
                />
              </div>
              <Link to={it.handle ? `/u/${it.handle}` : `/profile/${it.id}`} className="flex-1 min-w-0">
                <div className="text-sm text-white truncate hover:text-[#00aaff]">{it.name}</div>
                <div className="font-mono-tech text-[10px] text-[#94a3b8] truncate">@{it.handle} · {it.subtitle}</div>
              </Link>
              <FollowButton profile={{ id: it.id, type: it.type === "org" ? "organization" : "user", is_following: false }} onChange={(f) => handleFollow(i, f)} testIdPrefix={`suggest-follow-${it.id}`} />
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
}
